// extracted by mini-css-extract-plugin
export default {"melodyVideo":"zP-z","isFullWidth":"AP-z","landingPageVideo":"BP-z","play":"CP-z","iframeVideo":"DP-z","playHidden":"EP-z","fullwidth":"FP-z"};